import { forwardRef } from '@chakra-ui/react'

import Container from './Container'
import { Provider } from './Provider'
import type { Props } from './types'

export const Main = forwardRef<Props, 'div'>((props: Props, ref) => {
  return (
    <Provider props={props} ref={ref}>
      <Container />
    </Provider>
  )
})
